import React, { Component } from "react";

import TextField from "material-ui/TextField";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";

import LoginLayout from "./Layout";

import "./Login.css";

import { connect } from "react-redux";
import { push } from "react-router-redux";
import {
  authLogin,
  authResetPassword,
  snackbar,
  resetTmpPassword
} from "../app/actions";

class Login extends Component {
  state = {
    login: "",
    password: "",
    newPassword1: "",
    newPassword2: ""
  };

  handleChange = e => {
    const target = e.target;
    this.setState(state => ({ [target.name]: target.value }));
  };

  login = e => {
    e.preventDefault();
    this.setState({ newPassword1: "", newPassword2: "" });
    this.props.login(this.state.login, this.state.password);
  };

  resend = () => {
    this.props.resend();
  };

  resetPassword = e => {
    e.preventDefault();
    this.props.resetPassword(
      this.state.login,
      this.state.password,
      this.state.newPassword1,
      this.state.newPassword2
    );
  };

  renderLogin() {
    return (
      <form onSubmit={this.login}>
        <TextField
          name="login"
          value={this.state.login}
          onChange={this.handleChange}
          hintText="Saisir votre identifiant"
          floatingLabelText="Votre identifiant"
        />
        <TextField
          value={this.state.password}
          onChange={this.handleChange}
          name="password"
          type="password"
          hintText="Saisir votre mot de passe"
          floatingLabelText="Votre mot de passe"
        />
        <div className="buttons high">
          <RaisedButton
            type="submit"
            className="button"
            label="Connexion"
            primary
          />
          <FlatButton
            className="button"
            onClick={this.resend}
            label="Mot de passe oublié"
          />
        </div>
      </form>
    );
  }

  renderTmpPassword() {
    return (
      <form onSubmit={this.resetPassword}>
        <p className="message">
          Votre mot de passe est temporaire. Veuillez en choisir un nouveau.
        </p>
        <TextField
          value={this.state.newPassword1}
          onChange={this.handleChange}
          name="newPassword1"
          type="password"
          hintText="Saisir votre  mot de passe"
          floatingLabelText="Nouveau mot de passe"
        />
        <TextField
          value={this.state.newPassword2}
          onChange={this.handleChange}
          name="newPassword2"
          type="password"
          hintText="Re-saisir le mot de passe"
          floatingLabelText="Nouveau mot de passe"
        />
        <div className="buttons">
          <RaisedButton type="submit" label="Changer le mot de passe" primary />
        </div>
      </form>
    );
  }

  render() {
    return (
      <LoginLayout>
        {this.props.tmpPassword ? this.renderTmpPassword() : this.renderLogin()}
      </LoginLayout>
    );
  }
}

/************** Container Part */

const mapStateToProps = state => ({
  tmpPassword: state.app.auth.tmpPassword
});

const mapDispatchToProps = dispatch => ({
  login: (login, password) => {
    dispatch(authLogin(login, password));
  },

  resend: () => {
    dispatch(push("/mot-de-passe-oublie"));
  },

  resetPassword: (login, password, newPassword1, newPassword2) => {
    if (login && login.length > 0 && password && password.length > 0) {
      dispatch(
        newPassword1 === newPassword2
          ? authResetPassword(login, password, newPassword1)
          : snackbar("Les mots de passe ne sont pas identiques")
      );
    } else {
      dispatch(resetTmpPassword());
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/login/Login.js